<div [class]="class"><canvas #chart></canvas></div>